<div class="navigation-wrap bg-light start-header start-style">
  <div class="row">
    <div class="col-12">
      <nav class="navbar navbar-expand-md navbar-light">

        <button i18n class="navbar-toggler" type="button">
          <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" >
          <ul class="navbar-nav ml-auto py-4 py-md-0">
            <li class="nav-item pl-4 pl-md-0 ml-0 ml-md-4">
              <a i18n style="color: #470037; cursor: pointer;">
                <mat-icon>search</mat-icon>
              </a>
            </li>
            <li class="nav-item pl-4 pl-md-0 ml-0 ml-md-4">
              <div class="nav-link-box" data-toggle="dropdown">
                <img src="./assets/image/profile.svg" alt="profile" class="nav-avatar">
                <a i18n class="nav-link dropdown-toggle" href="#" role="button" aria-haspopup="true"
                  aria-expanded="false">{{username}}</a>
                <mat-icon class="arrow-icon">keyboard_arrow_down</mat-icon>
              </div>
              <div class="dropdown-menu">
                <a i18n class="dropdown-item" href="#">Action</a>
                <a i18n class="dropdown-item" href="#">Another action</a>
                <a i18n class="dropdown-item" href="#">Something else here</a>
                <a i18n class="dropdown-item" href="#">Another action</a>
              </div>

            </li>
          </ul>
        </div>
        <div class="nav-box">
          <div class="item-list">
            <a i18n style="color: #470037; cursor: pointer;">
              <mat-icon>search</mat-icon>
            </a>
  
            <div class="profile" data-toggle="dropdown">
              <img src="./assets/image/profile.svg" alt="profile" class="nav-avatar dropdown-toggle">
              <a i18n class="nav-link dropdown-toggle" href="#" role="button" aria-haspopup="true"
                aria-expanded="false">{{username}}</a>
              <mat-icon class="arrow-icon">keyboard_arrow_down</mat-icon>
            </div>
            <div class="dropdown-menu">
              <a i18n class="dropdown-item" href="#">Action</a>
              <a i18n class="dropdown-item" href="#">Another action</a>
              <a i18n class="dropdown-item" href="#">Something else here</a>
              <a i18n class="dropdown-item" href="#">Another action</a>
            </div>
          </div>
          </div>
          
      </nav>
    </div>
  </div>
</div>

<router-outlet></router-outlet>